import { IAMAccountFacade } from "./iam-account.facade";
import { IAMAccountsFacade } from "./iam-accounts.facade";

export { IAMAccountFacade, IAMAccountsFacade };

export default [IAMAccountFacade, IAMAccountsFacade];
